import "antd/lib/modal/style";
import _Modal from "antd/lib/modal";
import "antd/lib/space/style";
import _Space from "antd/lib/space";
import "antd/lib/button/style";
import _Button from "antd/lib/button";
import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "antd/lib/typography/style";
import _Typography from "antd/lib/typography";
var __jsx = React.createElement;
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.from.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import config from 'config';
import { getBackendStatus } from 'redux/selectors';
import { discardChangedQCFilters } from 'redux/actions/experimentSettings';
import { runQC } from 'redux/actions/pipeline';
import QCRerunDisabledModal from 'components/modals/QCRerunDisabledModal';
import { getUserFriendlyQCStepName } from 'utils/qcSteps';
import isUserAuthorized from 'utils/access/isUserAuthorized';
import { getURL } from 'redux/actions/pipeline/runQC';
var Text = _Typography.Text;
var ChangesNotAppliedModal = function ChangesNotAppliedModal(props) {
  var _backendStatus$gem2s;
  var onRunQC = props.onRunQC,
    onDiscardChanges = props.onDiscardChanges,
    onCloseModal = props.onCloseModal;
  var experimentId = useSelector(function (state) {
    return state.experimentSettings.info.experimentId;
  });
  var changedQCFilters = useSelector(function (state) {
    return state.experimentSettings.processing.meta.changedQCFilters;
  });
  var pipelineVersion = useSelector(function (state) {
    return state.experimentSettings.info.pipelineVersion;
  });
  var _useSelector = useSelector(getBackendStatus(experimentId)),
    backendStatus = _useSelector.status;
  var _useState = useState(null),
    runQCAuthorized = _useState[0],
    setRunQCAuthorized = _useState[1];
  var shouldRerun = backendStatus === null || backendStatus === void 0 || (_backendStatus$gem2s = backendStatus.gem2s) === null || _backendStatus$gem2s === void 0 ? void 0 : _backendStatus$gem2s.shouldRerun;
  var dispatch = useDispatch();
  var _useState2 = useState(false),
    QCDisabledModalVisible = _useState2[0],
    setQCDisabledModalVisible = _useState2[1];
  var runQCIfPossible = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var oldQCVersion;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            oldQCVersion = pipelineVersion < config.pipelineVersionToRerunQC;
            if (oldQCVersion || !runQCAuthorized) {
              setQCDisabledModalVisible(true);
            } else {
              dispatch(runQC(experimentId));
              onRunQC();
            }
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function runQCIfPossible() {
      return _ref.apply(this, arguments);
    };
  }();
  var closeModals = function closeModals() {
    setQCDisabledModalVisible(false);
    onCloseModal();
  };
  useEffect(function () {
    isUserAuthorized(experimentId, getURL(experimentId), 'POST').then(setRunQCAuthorized);
  }, []);
  return __jsx(React.Fragment, null, QCDisabledModalVisible && __jsx(QCRerunDisabledModal, {
    experimentId: experimentId,
    onFinish: closeModals,
    visible: QCDisabledModalVisible,
    runQCAuthorized: runQCAuthorized
  }), __jsx(_Modal, {
    title: "Changes not applied",
    onCancel: function onCancel() {
      return onCloseModal();
    },
    open: !QCDisabledModalVisible,
    footer: __jsx(_Space, {
      size: "large",
      style: {
        display: 'flex',
        justifyContent: 'center'
      }
    }, __jsx(_Button, {
      type: "primary",
      key: "run",
      disabled: !experimentId || !shouldRerun,
      onClick: function onClick() {
        runQCIfPossible();
      },
      style: {
        width: '100px'
      }
    }, "Run"), __jsx(_Button, {
      type: "primary",
      key: "discard",
      onClick: function onClick() {
        dispatch(discardChangedQCFilters());
        onDiscardChanges();
      },
      style: {
        width: '100px'
      }
    }, "Discard"))
  }, __jsx("center", null, __jsx(_Space, {
    direction: "vertical"
  }, "Your changes to the settings of these filters are not yet applied:", changedQCFilters.size > 0 && __jsx(React.Fragment, null, __jsx("br", null), __jsx("ul", {
    style: {
      margin: '0 auto',
      display: 'table'
    }
  }, Array.from(changedQCFilters).map(function (step) {
    return __jsx("li", null, __jsx("b", {
      style: {
        float: 'left'
      }
    }, getUserFriendlyQCStepName(step)));
  })), __jsx("br", null)), __jsx(Text, null, "Would you like to rerun data processing with these new settings, or discard the changes?")))));
};
ChangesNotAppliedModal.defaultProps = {
  onRunQC: null,
  onDiscardChanges: null,
  onCloseModal: null
};
export default ChangesNotAppliedModal;